export const HOME_PAGE_URL = '/home';